import { DEFAULT_MEDIA_COLOR_BY_THEME } from "@/src/constants/fast";
import { useTheme } from "@/src/contexts/ThemeContext";

export default function useDefaultMediaColor(): string {
  const { resolvedTheme } = useTheme();
  return DEFAULT_MEDIA_COLOR_BY_THEME[resolvedTheme];
}
